// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TripleCheckPatientRequest } from './tripleCheckPatientRequest.js';
import type { TripleCheckPrescriberRequest } from './tripleCheckPrescriberRequest.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TripleCheckInputRequest {
    'patient': TripleCheckPatientRequest | null;
    'prescriber'?: TripleCheckPrescriberRequest | null;
    'daysSupply'?: string;
    'ndc': string;
    'pharmacyNcpDpId'?: string;
    'pharmacyNpi': string;
    'project'?: string;
    'quantity'?: string;
    'clientId1'?: string;
    'clientId2'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TripleCheckInputRequest>> = [
        {
            "name":     "patient",
            "baseName": "patient",
            "type":     "TripleCheckPatientRequest"
        },
        {
            "name":     "prescriber",
            "baseName": "prescriber",
            "type":     "TripleCheckPrescriberRequest"
        },
        {
            "name":     "daysSupply",
            "baseName": "daysSupply",
            "type":     "string"
        },
        {
            "name":     "ndc",
            "baseName": "ndc",
            "type":     "string"
        },
        {
            "name":     "pharmacyNcpDpId",
            "baseName": "pharmacyNcpDpId",
            "type":     "string"
        },
        {
            "name":     "pharmacyNpi",
            "baseName": "pharmacyNpi",
            "type":     "string"
        },
        {
            "name":     "project",
            "baseName": "project",
            "type":     "string"
        },
        {
            "name":     "quantity",
            "baseName": "quantity",
            "type":     "string"
        },
        {
            "name":     "clientId1",
            "baseName": "clientId1",
            "type":     "string"
        },
        {
            "name":     "clientId2",
            "baseName": "clientId2",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TripleCheckInputRequest.attributeTypeMap;
    }
}
